module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8n7n2r5r-6e59d9c8fd12286ba8e9395b2dbffee5.svg";